import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const muiStyles = createTypedSxStyles({
  colorBadge: {
    display: 'flex',
    border: `1px solid ${foundations.colors.gray100}`,
    borderRadius: '50%',
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    backgroundColor: foundations.colors.white,
    width: '16px',
    height: '16px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectedIcon: {
    fill: foundations.colors.green600,
    fontSize: '16px',
  },
  removeButton: {
    cursor: 'pointer',
    backgroundColor: foundations.colors.red700,
    zIndex: 2,
  },
  removeIcon: {
    color: foundations.colors.white,
    fontSize: '10px',
  },
  colorTextField: {
    '& input': {
      height: 'auto',
      width: 'auto !important',
      borderLeft: 'unset !important',
      borderRadius: 'unset !important',
      outline: 'unset',
      border: 'none !important',
      boxShadow: 'none !important',
    },
    '& input:focus': {
      border: 'none !important',
      outline: 'none !important',
      boxShadow: 'none !important',
    },
  },
});
